import React from "react";
import "./styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import KC_Icon_Button from "../../../../designsystem/KC_Button/KC_Icon_Button";
import {
  faArrowRight,
  type IconDefinition
} from "@fortawesome/free-solid-svg-icons";
import { tt } from "../../../../utils/i18n/i18n";

interface StepRowProps {
  isActive: boolean;
  id?: string;
  title?: string;
  icon?: IconDefinition;
  svg?: JSX.Element;
  onClick?: () => void;
  showCheckStatus?: boolean;
  noCheck?: boolean;
}

export default function StepRow(props: StepRowProps) {
  return (
    <div className={"d-flex align-items-center gap-sm"}>
      <div
        className={
          "w-100 d-flex align-items-center justify-content-between kc-step-row-jp"
        }
        id={props.id}
        style={{ cursor: "pointer" }}
        onClick={props.onClick}
      >
        <div className={"d-flex align-items-center st-gap gap-md"}>
          <span>
            {props.svg != null && <>{props.svg}</>}
            {props.icon != null && <FontAwesomeIcon icon={props.icon} />}
          </span>
          <KC_UIText weight={KC_Weights.bold} text={props.title || ""} />
        </div>
        <div>
          {!props.isActive ? (
            <KC_Button
              type={KC_ButtonType.Button}
              isPrimary={true}
              text={tt("jp_proceed")}
              icon={faArrowRight}
              showIconOnTheRight={true}
              size={KC_ButtonSize.Large}
              className="d-flex"
            />
          ) : (
            <div className="d-flex align-items-center st-gap">
              {!props.noCheck && (
                <KC_Button
                  isInverted={true}
                  className="d-flex border"
                  type={KC_ButtonType.Button}
                  text={tt("form_button_modify")}
                  size={KC_ButtonSize.Large}
                />
              )}
              {props.noCheck && (
                <KC_Icon_Button
                  type={KC_ButtonType.Button}
                  isInverted={true}
                  size={KC_ButtonSize.Large}
                  icon={faArrowRight}
                  className="d-flex"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
